/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import { fetchWithAuth } from './requests';
import { LoadStatus } from '../types';

/**
 *
 * @param state
 * @param defaultState
 */
export function resetImmerState<State>(state: State, defaultState: object) {
  // TODO: Figure out how to properly type this
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.getOwnPropertyNames(defaultState)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    state[key] = defaultState[key];
  }
}

type StatusSetter = (status: LoadStatus) => any;
/**
 *
 * @param setStatus
 * @param cb
 * @param path
 * @param fetchOpts
 * @param checkTaskCount
 */
export async function fetchWithStatus<ResponseType>(
  setStatus: StatusSetter,
  cb: (resp: ResponseType) => void | Promise<void>,
  path: string,
  fetchOpts: RequestInit = {},
  checkTaskCount?: boolean
) {
  setStatus('loading');
  try {
    const resp = await fetchWithAuth(path, fetchOpts);
    if (!resp.ok) {
      throw new Error('Bad Response');
    }
    if (resp.status !== 204) {
      const result: ResponseType = await resp.json();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (checkTaskCount && result.count === 0) {
        setStatus('noTasksLeft');
        return;
      }
      await cb(result);
    }
    setStatus('success');
  } catch {
    setStatus('failed');
  }
}
